<template>
    <!-- :style="'background:' + `url(${codeBg}) no-repeat`" -->
    <div class="code" >
        <div class="code-bg" v-if="codeBg">
            <img class="code-bg-top" src="@/assets/ios-long-picture.png" alt="">
            <!-- <div class="code-bg-w">
                <img class="code-bg-w-imgs" :src="codeBg" alt="">
                <img class="code-bg-w-b" src="@/assets/code/code-b.jpg" alt="">
                <img class="code-bg-w-title" src="@/assets/code/code-title.png" alt="">
            </div> -->
        </div>
        <!--  -->
    </div>
</template>

<script>
import { ref, getCurrentInstance, onMounted, onCreated } from 'vue';
export default {
    // 微信分享二维码
    name: 'WechatCode',
    setup() {
        const { proxy } = getCurrentInstance();
        const codeBg = ref('')
        // 跳转App  /h5/jump_app
        const jumpApp = () => {
            proxy.$http.post('/h5/jump_app').then(({ data: res }) => {
                if(res.success) {
                    codeBg.value = res.data.qrCode
                }
            })
        }
        onMounted(async () => {
            // getAgentList()
            jumpApp()
        })
        return {
            codeBg
        }
    }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>